<template>
<div>
  <section class="duration">
    <div class="average-column-total">
        <div class="avg-button" style="height: 33px;">
        </div>
        <div class="avg-button-bottom">
              <div class="outliers-count">
                <span class="count-number">{{overDue.total}}</span> 
                <span class="count-label">Outliers</span>
              </div>
        </div>
    </div>
    <div class="dashboard-buttons">
      <div class="tile-button average-column">
        
        <div class="average-column" @click="ShowOutlinerKits(4,'processing','overduelist')">
          <div  class="shipping avg-button">
              <span v-if="kitavg">{{kitavg.ordered_to_shipped_date}}</span> 
          </div>
          <div  class="avg-button-bottom">
              <span class="shipping-span">{{overDue.shipped_count}}</span> 
          </div>
        </div>
        <div class="average-column" @click="ShowOutlinerKits(4,'shipped','overdue')">
          <div class="delivery avg-button">
              <span  v-if="kitavg">{{kitavg.shipped_to_delivered_date}}</span> 
          </div>
          <div  class="avg-button-bottom">
              <span class="delivery-span">{{overDue.delivered_count}}</span> 
          </div>
        </div>
        <div class="average-column"  @click="ShowOutlinerKits(4,'delivered')" >
          <div  class="activation avg-button">
              <span  v-if="kitavg">{{kitavg.delivered_to_activated_date}}</span> 
          </div>
          <div  class="avg-button-bottom">
              <span class="activation-span">{{overDue.activated_count}}</span> 
          </div>
        </div>
        <div class="average-column" @click="ShowOutlinerKits(4,'activated')">
          <div class="awaiting avg-button">
              <span  v-if="kitavg">{{kitavg.activated_to_intransit_date}}</span> 
          </div>
          <div  class="avg-button-bottom">
              <span class="awaiting-span">{{overDue.awaiting_count}}</span> 
          </div>
        </div>
        <div class="average-column"  @click="ShowOutlinerKits(4,'awaiting')">
          <div class="received avg-button">
              <span  v-if="kitavg">{{kitavg.intransit_to_lab_received_date}}</span> 
          </div>
          <div class="avg-button-bottom">
              <span class="received-span">{{overDue.received_count}}</span> 
          </div>
        </div>
        <div class="average-column" @click="ShowOutlinerKits(4,'received')">
          <div class="completed avg-button">
            <span  v-if="kitavg">{{kitavg.lab_received_to_complete_date}}</span> 
          </div>
          <div class="avg-button-bottom">
              <span class="completed-span">{{overDue.completed_total}}</span> 
          </div>
        </div>
      </div>
    </div>
  </section>
  <div v-if="overDue.last_run_date" class="last-run-date">
             Last update on: {{ formatDate(overDue.last_run_date) }}
  </div>
</div>
</template>

<script>
import { mapGetters,mapActions } from "vuex";
import moment from 'moment';
  export default {
    name: "DurationTimeline",
    data() {
     return {
       kitavg:{},
       overDue:{},
     }
    },
    computed:{
      ...mapGetters(['getTestKitAvg','getOverDues'])
    },
    methods: {
        ...mapActions(['testKitAvg','overDues','setOverDueByShipped','setOverDueByStyle']),
        sortbydays(e){
           this.testKitAvg(e.target.value).then(res => {
           });
        },
        ShowOutlinerKits(steps,status,type = null)
        {
          this.setOverDueByShipped(type);
          if(type == null) {
            type = 'style';
          }
          this.setOverDueByStyle(status+type);
          this.$emit("showoutlinerkits",{ steps: steps, value: status});
        },
        formatDate(date) {
            return moment(date).format('MM/DD/YY HH:mm');
        }
    },
    async mounted(){
      await this.testKitAvg();
      this.kitavg = this.$store.getters.getTestKitAvg;
      this.overDue = this.$store.getters.getOverDues;
    },
     watch: {
       getTestKitAvg(obj){
         this.kitavg = obj;
       },
       getOverDues(obj){
        this.overDue = obj;
       }
     }
  };
</script>
<style>


.btn-filter-item {
 background-color: #fff;
  color: #000000;
  border: 1px solid transparent;
  -webkit-transition: all 0.5s linear;
  transition: all 0.5s linear;
}

</style>

<style lang="sass" scoped>
@import "../../../styles/colors";

* 
  box-sizing: border-box
  font-family: TTNormsMedium, sans-serif
  padding: 0
  margin: 0
.last-run-date
    color: black
    font-size: .875rem
    font-family: TTNormsMedium,sans-serif
    display: flex;
    line-height: 0px;
section.duration
  display: flex // Ensure flex is properly applied here
  display: flex
  .average-column-total
    color: white
    display: block
    max-width: 100%
    text-align: center
    width: 90px
    display: grid
    line-height: 1.2rem
    
    .avg-button-bottom
      padding: 20px 0 10px
      border-radius: 100px
      font-size: 0.875rem
      font-weight: 500
      
      .outliers-count
        color: black
        margin-bottom: 5px
        
        .count-number
          font-size: .875rem
          font-family: TTNormsMedium,sans-serif
          
        .count-label
          font-size: .875rem
          padding-left: 5px
          font-family: TTNormsMedium,sans-serif

  .dashboard-buttons
    .tile-button
      display: flex
      justify-content: center
      list-style: none
      overflow: hidden
      font-size: 0.75rem
      right: 42px
      position: relative
      .average-column
        color: white
        display: block
        max-width: 100%
        margin: 0 10px
        text-align: center
        overflow: hidden
        cursor: pointer
        width: 145px

        .avg-button
          padding: 10px 0
          border-radius: 100px

        .avg-button-bottom
          padding: 20px 0 10px
          border-radius: 100px
          font-size: 0.875rem
          font-weight: 500

        .shipping 
          background-color: $green
          font-size: 0.75rem

        .delivery
          background-color: $blue
          font-size: 0.75rem

        .activation
          background-color: $lightGray
          font-size: 0.75rem

        .awaiting
          background-color: $yellow
          font-size: 0.75rem

        .received
          background-color: $heather
          font-size: 0.75rem

        .completed
          background-color: $caribbeanBlue
          font-size: 0.75rem

        span.shipping-span
          color: $green

        span.delivery-span
          color: $blue

        span.activation-span
          color: $lightGray

        span.awaiting-span
          color: $yellow

        span.received-span
          color: $heather

        span.completed-span
          color: $caribbeanBlue

.activation
  i
    font-size: 0.75rem
    margin-bottom: 10px

/* small */
@media (min-width: 20em)
  p:after
    content: "small screens"
    color: darkslategray
    font-weight: 500

  .tile-button li
    width: 45.5%
    float: left

/* large */
@media (min-width: 40em)
  p:after
    content: "med screens && larger"
    color: darkslategray
    font-weight: 500

  .tile-button li
    width: 23%

.shipped-column-cursor
  cursor: context-menu !important

@media (max-width: 73.5em)
  section.duration
    div.dashboard-buttons
      .tile-button
        display: flex
        justify-content: center
        list-style: none
        overflow: hidden
        font-size: 0.75rem
        left: -41px
        position: relative
        width: 97%
        .average-column
          color: white
          display: block
          max-width: 100%
          margin: 0 10px
          text-align: center
          overflow: hidden
          cursor: pointer
          width: 105px
</style>
